<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div class="p-1 text-left fw-bold rounded border border-white" :style="`background-color: ${completedVehicle.backgroundColor ?? trailer.backgroundColor ?? '#ffffff'}; color: ${completedVehicle.textColor ?? trailer.textColor ?? '#000000'};`">
    <div class="d-flex justify-content-between">
      <div class="text-sm-secondary">
        <Popper placement="right">
          <span class="p-1" role="button">
            <span v-if="place === 'StoreHouse'">
              {{ trailer.id }}.
            </span>
            <span>
              {{ trailer.plateNumber }}
            </span>
            <span v-if="trailer.hidden"> (UKRYTA) </span>
          </span>

          <template #content>
            <button
              class="btn btn-danger"
              data-bs-toggle="modal"
              data-bs-target="#selectTrailerParkingModal"
              @click="launchSelectTrailerParkingModal"
              >
              Odepnij naczepę
            </button>
            <br>
            <div v-if="place === 'StoreHouse'">
              <button class="btn btn-danger mt-2" @click="DeleteTrailer">
                Usuń naczepę
              </button>
              <br>
              <Popper placement="right">
                <button class="btn btn-primary mt-2">
                  Edytuj naczepę
                </button>
                <template #content>
                  <br>
                  <form @submit.prevent="UpdateTrailer">
                    <input type="text" placeholder="Nazwa" class="w-200" v-model="trailer.plateNumber">
                    <button class="mt-2 btn btn-primary" type="submit">
                      Zapisz
                    </button>
                  </form>
                </template>
              </Popper>
            </div>
          </template>
        </Popper>
        <br>
        <div
          v-show="trailer.comments.length"
          class="fw-bolder notebook-btn text-xs"
          data-bs-toggle="modal"
          data-bs-target="#trailerCommentModal"
          @click="launchTrailerCommentModal(trailer)"
          role="button">
          NOTES {{ trailer.comments.length }}
        </div>
      </div>
      <div class="text-xl">
        <Popper placement="right">
          <span class="text-darker px-1" role="button">
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </span>
          <template #content>
            <CommentCreator :vehicle-id="vehicle?.id" :trailer-id="trailer.id" />
            <div class="text-sm my-2" role="button" @click="ChangeTrailerHidden(true)" v-if="!trailer.hidden">
              Ukryj naczepę
            </div>
            <div class="text-sm my-2" role="button" @click="ChangeTrailerHidden(false)" v-else>
              Wyłącz ukrywanie naczepy
            </div>
            <div class="text-sm mt-2 user-select-none" role="button">
              Kolor czcionki
              <div class="colorsPallete">
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #f8f9fa; display: inline;" @click="changeTextColor('#f8f9fa')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #47d147; display: inline;" @click="changeTextColor('#47d147')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #66FFFF; display: inline;" @click="changeTextColor('#66FFFF')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ffff66; display: inline;" @click="changeTextColor('#ffff66')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ff471a; display: inline;" @click="changeTextColor('#ff471a')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ff9900; display: inline;" @click="changeTextColor('#ff9900')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #cccccc; display: inline;" @click="changeTextColor('#cccccc')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #3399FF; display: inline;" @click="changeTextColor('#3399FF')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #bf00ff; display: inline;" @click="changeTextColor('#bf00ff')"></div>
                <div class="mx-1 px-1 border border-1" role="button" style="background-color: #222222; display: inline;" @click="changeTextColor('#222222')"></div>
              </div>
            </div>
            <div class="text-sm mt-2 user-select-none">
              Kolor komórki
              <div>
                <div class="colorsPallete">
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #f8f9fa; display: inline;" @click="changeBgColor('#f8f9fa')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #47d147; display: inline;" @click="changeBgColor('#47d147')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #66FFFF; display: inline;" @click="changeBgColor('#66FFFF')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ffff66; display: inline;" @click="changeBgColor('#ffff66')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ff471a; display: inline;" @click="changeBgColor('#ff471a')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #ff9900; display: inline;" @click="changeBgColor('#ff9900')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #cccccc; display: inline;" @click="changeBgColor('#cccccc')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #3399FF; display: inline;" @click="changeBgColor('#3399FF')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #bf00ff; display: inline;" @click="changeBgColor('#bf00ff')"></div>
                  <div class="mx-1 px-1 border border-1" role="button" style="background-color: #222222; display: inline;" @click="changeBgColor('#222222')"></div>
                </div>
              </div>
            </div>
          </template>
        </Popper>
      </div>
    </div>
  </div>
</template>

<script>
import Popper from 'vue3-popper'
import axios from 'axios'
import emitter from '@/modules/events/emitter'
import Swal from 'sweetalert2'
import CommentCreator from '@/components/TasksCalendar/Comments/Trailer/CommentCreator.vue'
import colors from '@/modules/cells/colors'
import eventKinds from '@/modules/events/eventKinds'
import { $axios } from '@/modules/http/axios'

export default {
  name: 'TrailerCell',
  components: { Popper, CommentCreator },
  props: ['trailer', 'isVerticallyExpanded', 'place', 'vehicle', 'withPlateNumber'],
  data () {
    return {
      selectedCellColor: '#FFFFFF',
      selectedTextColor: '#222222',
      completedVehicle: this.trailer,
      altVehicle: null,
      isCellExpanded: false,
      colors: colors,
      labelTitle: '',
      labelTextColor: '',
      labelBackgroundColor: '',
      // comments: this.trailer.comments,
      comment: {
        title: '',
        textColor: '',
        backgroundColor: '',
        mails: '',
        sendNotificationOn: null
      },
      openedPopperCommentId: null
    }
  },
  created () {
    if (!this.vehicle) {
      this.setVehicle()
    }
  },
  computed: {
    mailings () {
      return this.$store.getters.getCalendarMailings
    }
  },
  methods: {
    launchTrailerCommentModal (trailer) {
      emitter.emit(eventKinds.trailerCommentModalRequested, { trailer: trailer })
    },
    async setVehicle () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      this.altVehicle = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Vehicle`, config)).data.find(v => v.semiTrailer?.id === this.trailer.id)
    },

    changeBgColor (bgC) {
      this.completedVehicle.backgroundColor = bgC
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("accessToken")}`);
      const raw = JSON.stringify({
        textColor: this.completedVehicle.textColor,
        backgroundColor: bgC,
        plateNumber: this.completedVehicle.plateNumber
      });
      var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, requestOptions)
        .then(response => response.text())
        .then(result => {
          // document.querySelector(".box1").style = "display: none;"
        })
        .catch(error => console.log('error', error));
    },
    changeTextColor (tC) {
      this.completedVehicle.textColor = tC
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append("Authorization", `Bearer ${localStorage.getItem("accessToken")}`);
      const raw = JSON.stringify({
        textColor: tC,
        backgroundColor: this.completedVehicle.backgroundColor,
        plateNumber: this.completedVehicle.plateNumber
      });
      // console.log(raw);
      // console.log(this.trailer.id);
      var requestOptions = {
        method: 'PUT',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      };

      fetch(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, requestOptions)
        .then(response => response.text())
        .then(result => {
          console.log(result)
          // document.querySelector(".box1").style = "display: none;"
        })
        .catch(error => console.log('error', error))
    },
    launchSelectTrailerParkingModal () {
      emitter.emit(eventKinds.selectTrailerParkingModalRequested, { vehicle: this.vehicle, trailer: this.trailer })
    },
    ChangeTrailerHidden (bool) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      const putData = {
        hidden: bool
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.trailer.hidden = bool
      axios.put(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, putData, config).then(() => {
        Swal.fire('Sukces', 'Pomyślnie wykonano akcję.', 'success')
        emitter.emit('trailerVisibilityChanged', { trailerId: this.trailer.id })
      })
    },
    TrailerEdit () {
      this.$router.push({
        name: 'EditTrailer',
        params: {
          id: this.id
        }
      })
    },
    DeleteTrailer () {
      Swal.fire({
        title: 'Czy na pewno chcesz usunąć naczepę?',
        text: 'Usunięcie naczepy spowoduje usunięcie wszystkich komentarzy i etykiet.',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń naczepę!',
        icon: 'info'
      }).then((result) => {
        if (result.value) {
          const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
          axios.delete(process.env.VUE_APP_API_BASE_URL + 'Trailer/' + this.trailer.id, config)
            .then(response => {
              Swal.fire(
                'Usunięto!',
                'Naczepa została usunięta.',
                'success'
              )
              this.$emit('delete', this.id)
            })
        }
      })
    },
    async updateVehicle (key, value) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.get(process.env.VUE_APP_API_BASE_URL + 'Trailer/' + this.trailer.id, config)
        .then(response => {
          this.completedVehicle = response.data
          this.completedVehicle[key] = value

          axios.put(process.env.VUE_APP_API_BASE_URL + 'Trailer/' + this.trailer.id, {
            textColor: this.completedVehicle.textColor,
            backgroundColor: this.completedVehicle.backgroundColor,
            plateNumber: this.completedVehicle.plateNumber
          }, config)
            .then(response => {
              //
            })
            .catch(error => {
              console.log(error)
            })
        })

      axios.put(process.env.VUE_APP_API_BASE_URL + 'Trailer/' + this.id, {

      }, config)
    },
    handleNewLine (str) {
      return str.replace(/(?:\r\n|\r|\n)/g, '<br />')
    },
    AddComment () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      const postdata = {
        title: this.comment.title,
        textColor: this.comment.textColor,
        backgroundColor: this.comment.backgroundColor,
        content: this.comment.content,
        MailNotificationRecipients: this.comment.mails.split(','),
        sendNotificationOn: this.comment.sendNotificationOn
      }

      axios.post(process.env.VUE_APP_API_BASE_URL + 'Comment/Semitrailer/' + this.trailer.id, postdata, config)
        .then(response => {
          Swal.fire({
            title: 'Komentarz dodany',
            text: 'Komentarz został dodany',
            type: 'success',
            confirmButtonText: 'OK'
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    deleteComment (trailerId, id) {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      axios.delete(process.env.VUE_APP_API_BASE_URL + 'Comment/' + id, config)
        .then(response => {
          Swal.fire({
            title: 'Komentarz usunięty',
            text: 'Komentarz został usunięty',
            icon: 'success',
            confirmButtonText: 'OK'
          })

          emitter.emit(eventKinds.trailerCommentDeleted, { trailerId: trailerId })
        })
        .catch(error => {
          console.log(error)
        })
    },
    UpdateTrailer () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }

      const postdata = this.trailer

      axios.put(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, postdata, config)
        .then(response => {
          Swal.fire({
            title: 'Naczepa zaktualizowana',
            text: 'Naczepa została zaktualizowana',
            type: 'success',
            confirmButtonText: 'OK',
            icon: 'success'
          })
          this.$emit('delete', this.id)
        })
        .catch(error => {
          console.log(error)
          Swal.fire({
            title: 'Błąd',
            text: 'Nie udało się zaktualizować naczepy. Proszę sprawdzić wszystkie pola',
            type: 'error',
            confirmButtonText: 'OK',
            icon: 'info'
          })
        })
    },
    async reFetchTrailerComments () {
      const config = { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
      this.comments = (await axios.get(`${process.env.VUE_APP_API_BASE_URL}Trailer/${this.trailer.id}`, config)).data.comments
    },
    async reFetchTrailerColors () {
      const trailer = (await $axios.get(`Trailer/${this.trailer.id}`)).data
      this.completedVehicle.textColor = trailer.textColor
      this.completedVehicle.backgroundColor = trailer.backgroundColor
    }
  }
}
</script>

<style scoped>
.text-left {
  text-align: left;
}
.text-sm {
  font-size: .8rem;
}
.text-sm-secondary {
  font-size: .6rem;
}
.text-xs {
  font-size: .5rem;
}
.text-xl {
  font-size: 1.2rem;
}
.text-darker {
  color: #bbb;
}
.w-200 {
  width: 200px;
  height: 25px
}
</style>
